import React, { forwardRef, Ref, SVGProps } from 'react';

const SketchedCircles = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => {
  return (
    <svg
      height={128}
      viewBox="0 0 357 127"
      width={354}
      ref={ref}
      preserveAspectRatio="xMidYMid slice"
      {...props}
    >
      <g fill="none" fillRule="evenodd" stroke="currentColor">
        <path
          d="M242 17.5C198.5 5 130.5-.5 86.5 6.5 44.112 13.243-4.599 27.89 4 63c6 24.5 69 40.5 144 47 74.727 6.476 143 6.5 178.53-9.549 67.17-30.338-6.05-79.44-45.76-82.968C266.472 16.213 242 16.5 235 31"
          strokeLinecap="round"
          strokeWidth={6}
        />
        <path
          d="M250.48 35.497c0-26.077-114.437-30.163-193.813-13.68C-11.267 35.924-1.7 111.584 162.565 123.988c101.902 7.695 166.527-30.21 172.833-55.574 9.99-40.184-106.896-51.727-166.552-25.035"
          strokeWidth={3}
        />
      </g>
    </svg>
  );
};

export default forwardRef(SketchedCircles);
